class ReturnRequest {
    init() {
        let $selectAll = $('.orderOverview input.select-all');
        $selectAll.on('click', function () {
            let $lines = $('.orderOverview > .list > li input[name=checkbox]');
            $lines.prop('checked', true);
        });

        let $returnRequestSubmit = $('.return-request');

        $('input[name="checkbox"]').on('click', function () {
            $('#refund-error-block').hide();
            $('.orderOverview .indicator').attr('style','');
        });

        $returnRequestSubmit.on('click', () => {
            let $orderId = $('input[name=order-id]');
            let $selectedLines = $('.orderOverview > .list > li input[name=checkbox]:checked');
            let ids = $.map($selectedLines, (line) => {
                return $(line).val();
            });
            if (ids.length === 0) {
                $('#refund-error-block').show();
                $('.orderOverview .indicator').css('border', '1px solid red');
                var id  = $returnRequestSubmit.data('anchorLink');
                var top = $(id).first().offset().top;
                $('body,html').animate({scrollTop: top}, 1500);
                return false;
            }

            window.location = "/?action=retour/request&ordernumber=" + $orderId.val() + '&lines=' + ids.join(',');
        });
    }
}

$(document).ready(function () {
    let returnRequest = new ReturnRequest();

    returnRequest.init();
});
